import {
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useDisclosure,
  useToast,
  VStack,
} from "@chakra-ui/react"
import React, { useEffect, useState } from "react"
import { AiOutlineDelete } from "react-icons/ai"
import { BiEdit } from "react-icons/bi"
import { FiPlus } from "react-icons/fi"
import { useDispatch } from "react-redux"
import styles from "../SlotManagementTable/SlotEditorModal.module.scss"
import SlotDeleteConfirmation from "./SlotDeleteConfirmation"
import SlotEditorModal from "./SlotEditorModal"
import { format } from "date-fns"

interface Props {
  isOpen: boolean
  onClose: () => void
  restaurantIds?: string[]
  selectedDay?: string
}

interface Slot {
  time: string
  discount: number
  totalSeats: number
  seatsBooked: number
  _id: string
}

interface RestaurantData {
  _id: string
  slots: Slot[]
  restaurant: {
    name: string
    bookingFeePerPerson: {
      lunch: number
      dinner: number
    }
  }
}

type TimeSlot = "lunch" | "dinner"

interface ApiResponse {
  lunch: RestaurantData[]
  dinner: RestaurantData[]
}
const SlotDetailsModal: React.FC<Props> = ({
  isOpen,
  onClose,
  restaurantIds,
  selectedDay,
}) => {
  // console.log("restaurantIds", restaurantIds);
  // console.log("selectedDay", selectedDay);

  const toast = useToast()
  const dispatch = useDispatch()
  const [selectedRestaurant, setSelectedRestaurant] = useState<number | null>(
    null
  )
  const [selectedTime, setSelectedTime] = useState<TimeSlot>("lunch")
  const [restaurantData, setRestaurantData] = useState<
    ApiResponse | undefined
  >()
  const [targetevent, setTargetEvent] = useState<any>()

  const {
    isOpen: isEditorOpen,
    onOpen: onEditorOpen,
    onClose: onEditorClose,
  } = useDisclosure()

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure()

  const deletes = (slot: any, restaurantId: number) => {
    setTargetEvent(slot)
    setSelectedRestaurant(restaurantId)
    onDeleteOpen()
  }

  const handleAddSlot = (restaurantId: number) => {
    setTargetEvent(null)
    setSelectedRestaurant(restaurantId)
    onEditorOpen()
  }

  const updateEvent = (slot: any, restaurantId: number) => {
    setTargetEvent(slot)
    setSelectedRestaurant(restaurantId)
    onEditorOpen()
  }
  const fetchSlots = () => {
    // console.log("fetchSlots", restaurantIds, selectedDay, selectedTime);
    if (restaurantIds && selectedDay) {
      const payload = {
        restaurantId: restaurantIds,
        date: selectedDay,
        slotType: selectedTime,
      }

      dispatch({
        type: "REQUEST_CREATE_GET_MASTER_SLOTS",
        payload,
        onSuccess: (response: any) => {
          setRestaurantData(response.data.data)
        },
        onError: (error: any) => {
          toast({
            title: "Error",
            description: "Failed to fetch slots.",
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top-right",
          })
        },
      })
    }
  }

  useEffect(() => {
    if (isOpen && restaurantIds && selectedDay) {
      const payload = {
        restaurantId: restaurantIds,
        date: selectedDay,
        slotType: selectedTime,
      }

      dispatch({
        type: "REQUEST_CREATE_GET_MASTER_SLOTS",
        payload,
        onSuccess: (response: any) => {
          setRestaurantData(response.data.data)
          // console.log("Fetched slots successfully:", response.data.data);
          // toast({
          //   title: "Slots Loaded",
          //   description: "Slots have been fetched successfully.",
          //   status: "success",
          //   duration: 3000,
          //   isClosable: true,
          //   position: "top-right",
          // });
        },
        onError: (error: any) => {
          console.error("Error fetching slots:", error)
          toast({
            title: "Error",
            description: "Failed to fetch slots.",
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top-right",
          })
        },
      })
    }
  }, [isOpen, restaurantIds, selectedDay, dispatch, toast])

  const displayData = restaurantData ? restaurantData[selectedTime] : []

  useEffect(() => {
    if (isOpen && restaurantIds && selectedDay) {
      fetchSlots()
    }
  }, [selectedTime])

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          bg="#FDEDEC"
          borderBottom={"1px solid #E0E0E0"}
          borderTopLeftRadius={8}
          borderTopRightRadius={8}
        >
          <Text fontSize="2xl">{`Manage Slots: ${
            selectedDay ? format(new Date(selectedDay), "dd MMMM, yyyy") : ""
          }`}</Text>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody
          pb={6}
          maxHeight={"80vh"}
          // flex="1 1 auto"
          overflowY="auto"
          css={{
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "2px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },
          }}
        >
          <Flex justifyContent="space-between" alignItems="center">
            <Text fontSize="xl" pb={6}>
              Slots Availability
            </Text>

            <Select
              value={selectedTime}
              onChange={(e) => setSelectedTime(e.target.value as TimeSlot)}
              w="200px"
              bg="white"
            >
              <option value="lunch">Lunch</option>
              <option value="dinner">Dinner</option>
            </Select>
          </Flex>
          <VStack spacing={"0px"} align="stretch">
            {/* {displayData.length > 0 ? ( */}
            {displayData?.map((item: any, index: number) => (
              <Box key={item?._id}>
                {index > 0 && <Divider my={3} borderColor="gray.300" />}
                <Text fontSize="lg" fontWeight="medium">
                  {item?.restaurant?.name}
                </Text>
                <Flex
                  justifyContent={"flex-start"}
                  align="stretch"
                  gap={"12px"}
                  alignItems={"center"}
                >
                  <div className={styles.slotLeftDiv}>
                    <Button
                      variant="none"
                      height="100%"
                      onClick={() => handleAddSlot(item._id)}
                    >
                      <Flex
                        alignItems={"center"}
                        align="stretch"
                        flexDir={"column"}
                        justifyContent="center"
                        p={2}
                        gap={"12px"}
                        height={"100%"}
                      >
                        <Button
                          variant="none"
                          colorScheme="red"
                          size="sm"
                          color={"#E24441"}
                          fontSize={"md"}
                        >
                          Add Slot
                        </Button>
                        <Box
                          border={"1.2px solid #E24441"}
                          borderRadius={"8px"}
                          width={"30px"}
                          height={"30px"}
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <FiPlus color="#E24441" />
                        </Box>
                      </Flex>
                    </Button>
                  </div>
                  <div className={styles.slotDiv}>
                    {item?.slots && item?.slots?.length > 0 ? (
                      <Flex gap="12px">
                        {item.slots.map((slot: any) => (
                          <Box
                            key={slot._id}
                            border="1px"
                            borderColor="gray.200"
                            borderRadius="lg"
                          >
                            {index > 0 && <Divider />}
                            <Flex
                              alignItems="flex-start"
                              p={4}
                              flexDirection="column"
                              gap={2}
                            >
                              <Box>
                                <Text fontWeight="medium">{slot.time}</Text>
                                <Text fontSize="sm" color="gray.600">
                                  {/* Table: {slot?.seatsBooked}/{slot?.totalSeats} */}
                                  {/* Table: {slot?.seatsBooked.totalPeople || 0}/
                                  {slot.totalSeats} */}
                                  Table: {slot?.seatsBooked?.totalPeople || 0}/
                                  {slot?.totalSeats}
                                </Text>
                                <HStack spacing={2} pb="4px">
                                  <Text fontSize="sm" color="#08A799">
                                    {slot?.discount}% off
                                  </Text>
                                  <Text fontSize="sm" color="#08A799">
                                    •
                                  </Text>
                                  <Text fontSize="sm" color="#08A799">
                                    £
                                    {
                                      item?.restaurant?.bookingFeePerPerson[
                                        selectedTime
                                      ]
                                    }
                                  </Text>
                                </HStack>
                              </Box>
                              <Flex
                                alignSelf={"flex-end"}
                                gap={2}
                                marginLeft={"20px"}
                              >
                                <IconButton
                                  aria-label="Edit slot"
                                  icon={<BiEdit size="18px" color="#2C3545" />}
                                  variant="none"
                                  size="18px"
                                  onClick={() => updateEvent(slot, item._id)}
                                />
                                <IconButton
                                  aria-label="Delete slot"
                                  icon={
                                    <AiOutlineDelete
                                      size="18px"
                                      color="#E24441"
                                    />
                                  }
                                  variant="none"
                                  size="18px"
                                  onClick={() => deletes(slot, item._id)}
                                />
                              </Flex>
                            </Flex>
                          </Box>
                        ))}
                      </Flex>
                    ) : (
                      // ))}
                      <Text
                        fontSize="md"
                        color="gray.500"
                        // pl={4}
                        w="100%"
                        textAlign={"center"}
                      >
                        No slots available
                      </Text>
                    )}
                  </div>
                </Flex>
              </Box>
            ))}
            {/* ) : (
              <Text fontSize="lg" color="gray.500" textAlign="center">
                No restaurants available for the selected day and time.
              </Text>
            )} */}
          </VStack>
        </ModalBody>
      </ModalContent>
      {isEditorOpen && (
        <SlotEditorModal
          isEditorOpen={isEditorOpen}
          onEditorClose={onEditorClose}
          selectedRestaurant={selectedRestaurant}
          slotData={targetevent}
          selectedTime={selectedTime}
          selectedDay={selectedDay}
          restaurantIds={restaurantIds}
          onSlotsUpdate={fetchSlots}
        />
      )}
      {isDeleteOpen && targetevent && (
        <SlotDeleteConfirmation
          isDeleteOpen={isDeleteOpen}
          onDeleteClose={onDeleteClose}
          slotData={targetevent}
          selectedRestaurant={selectedRestaurant}
          selectedTime={selectedTime}
          onSlotsUpdate={fetchSlots}
        />
      )}
    </Modal>
  )
}

export default SlotDetailsModal
